<div class="screen-overlay" (click)="close()" *ngIf="overlay" [style.height]="(top > 0 ? top+'px' : '100dvh')"></div>
<div class="side-nav-content" [style.height]="(top > 0 ? top+'px' : '100dvh')">
<ng-container *ngTemplateOutlet="contentTpl"></ng-container>
<ng-template #contentTpl><ng-content></ng-content></ng-template>
</div>